import classNames from 'classnames';
import i18n from 'i18next';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from 'src/components/buttons/button';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import signupContext from 'src/constants/signupContext';
import { followCommunity, unfollowCommunity } from 'src/modules/community/shared/actions';
import { followPost, unfollowPost } from 'src/modules/community/singlePost/actions/actions';
import { showModal, showSignupModal } from 'src/modules/shared/modal/actions';
import Modal from 'src/modules/shared/modal/components/modal';
import { trackFootfallEvent } from 'src/utils/analytics';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

class FollowButton extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    followIds: PropTypes.array,
    followType: PropTypes.string,
    fullWidth: PropTypes.bool,
    community: PropTypes.object,
    isDisabled: PropTypes.bool,
    isFollowing: PropTypes.bool,
    linkStyle: PropTypes.bool,
    noIcon: PropTypes.bool,
    recommendStyle: PropTypes.bool,
    signupContext: PropTypes.object,
    silent: PropTypes.bool,
    toggleFollow: PropTypes.func,
    trackLabel: PropTypes.string,
    user: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool,
    ]),
  }

  static defaultProps = {
    community: {}, // Group object from api
    buttonStyle: 'blank',
    silent: false,
    isDisabled: false,
    followType: 'user',
    followIds: [],
    fullWidth: false,
    trackLabel: 'N/A',
    signupContext: {
      element: signupContext.element.FOLLOW,
      section: signupContext.section.UNTRACKED,
    },
    user: {},
  }

  constructor(props) {
    super(props);
    this.state = {hovered: false};
  }

  componentWillMount() {
    this.debouncedClick = debounce(this.onClick, 300);
  }

  triggerGroupLeavingModal = () => {
    const successMessage = i18n.t('You have left %1$s').replace('%1$s', this.props.community.name) + '!';
    this.props.showModal(
      <Modal
        title="Are you sure you want to do this?"
        cancel={i18n.t('Cancel')}
        accept={i18n.t('Unfollow Community')}
        onAccept={() => this.props.unfollowCommunity(this.props.community, this.props.user.userId, successMessage)}
      >
        <div>
          <p>{i18n.t('Unfollowing will affect your news feed, emails and badges.')}</p>
        </div>
      </Modal>);
  }

  onClick = () => {
    const {followType, community, isActive, user, trackLabel, signupContext, showSignupModal} = this.props;

    if (!isActive) {
      showSignupModal(
        this.props.signupContext,
        followType === 'group' ? community : undefined,
      );
      trackFootfallEvent(footfallEventTypes.CLICKED, {
        clickType: 'sign-up',
        clickMetadata: { ...signupContext },
      });
    } else if (followType === 'post') {
      if (this.props.isFollowing) {
        this.props.unfollowPost(this.props.followIds[0], i18n.t('Unfollowed!'));
      } else {
        this.props.followPost(this.props.followIds[0], trackLabel, i18n.t('Followed!'));
      }
    }
    else if (followType === 'group'){
      if (this.props.isFollowing) {
        this.triggerGroupLeavingModal();
      } else {
        this.props.followCommunity(community, user.userId, <FollowSuccessMessage communityName={community.name}/>);
      }
    }
  }

  getIcon(isFollowing, hovered, noIcon) {
    if(noIcon) return '';

    if(!isFollowing){
      return 'plus';
    } else {
      if (hovered) {
        return 'cancel';
      }
      return 'ok';
    }
  }

  render() {
    const { fullWidth, isFollowing, isDisabled, noIcon, linkStyle, size, className } = this.props;
    const {props, state} = this;
    const followingText = state.hovered ? i18n.t('Unfollow') : i18n.t('Following');
    const iconClasses = {
      'icon--success': true,
      'icon--danger': isFollowing && state.hovered && !noIcon,
    };
    const buttonText = props.buttonText || i18n.t('Follow');

    return (
      <Button
        className={className}
        disabled={isDisabled}
        fullWidth={fullWidth}
        icon={this.getIcon(isFollowing, state.hovered, noIcon)}
        iconClassName={classNames(iconClasses)}
        id={props.id}
        size={size}
        text={isFollowing ? followingText : props.children || buttonText}
        type={!linkStyle ? 'secondary' : 'none'}
        onClick={this.debouncedClick}
        onMouseEnter={() => this.setState({hovered: true})}
        onMouseLeave={() => this.setState({hovered: false})}
      />
    );
  }
}

const actions = {
  followPost,
  unfollowPost,
  followCommunity,
  unfollowCommunity,
  showSignupModal,
  showModal,
};

export default connect(null, actions)(FollowButton);



// WEBPACK FOOTER //
// ./src/components/buttons/followButton.js